import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "w-full tw fixedfees bg-white overflow-auto print:overflow-hidden",
  style: {
    "position": "absolute",
    "left": "0px"
  }
};
const _hoisted_2 = {
  class: "container overflow-hidden tw color-unset lineheight-unset flex flex-col"
};
const _hoisted_3 = {
  class: "flex h-full w-full"
};
const _hoisted_4 = {
  class: "pl-4 p-4 w-full"
};
import { ref, computed, watch, onMounted } from 'vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import { useEntriesStore } from '@/services/useEntriesStore';
import FixedFeesTable from './FixedFeesTable.vue';
import CreateChargeModal from './components/CreateChargeModal.vue';
import LlWarningBanner from '@/components/LlWarningBanner.vue';
import RouteService from '@/services/RouteService';
import EventTracker from '@/services/eventTracker';
import { TrackingAction } from '@/constants/trackingConstants';
export default {
  __name: 'FixedFeesPage',
  props: {
    state: {
      type: Object,
      required: false
    },
    leanLawAuth: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const meStore = useMeStore();
    const entriesStore = useEntriesStore();
    const routeService = new RouteService(props);
    const tableRef = ref(null);
    const showModal = ref(false);
    const unassignedCount = ref(0);

    // Computed route panel params - single source of truth from URL
    const routePanelParams = computed(() => {
      const params = props.state?.params;
      if (!params?.panel) return null;
      return {
        chargeId: params.chargeId || null,
        // matterId only for creating new fixed fee (no chargeId)
        matterId: params.chargeId ? null : params.matterId || null
      };
    });

    // Create stateParams that matches what CreateChargeModal expects
    // When modal=create, always create a NEW charge (ignore existing chargeId in URL)
    const modalStateParams = computed(() => {
      const params = props.state?.params;
      const isCreateMode = params?.modal === 'create';
      return {
        chargeId: isCreateMode ? null : params?.chargeId || null,
        matterId: params?.matterId || null,
        fixedFeeTemplate: params?.fixedFeeTemplate ?? false,
        ledes: params?.ledes ?? false,
        showAllocation: params?.showAllocation ?? false
      };
    });

    // Watch for the explicit modal param to control modal visibility
    watch(() => props.state?.params?.modal, modalParam => {
      showModal.value = !!modalParam;
    }, {
      immediate: true
    });

    // Handle modal close
    const handleModalClose = () => {
      // Explicitly close the modal immediately (don't rely on watcher with notify: false)
      showModal.value = false;
      if (props.state?.go) {
        props.state.go('fixedfees', {
          modal: null
        }, {
          notify: false,
          reload: false
        });
      }
      tableRef.value?.loadCharges?.();
      fetchUnassignedCount();
    };

    // Fetch unassigned fixed fee entry count
    const fetchUnassignedCount = async () => {
      await meStore.getMe();
      unassignedCount.value = await entriesStore.getUnassignedFixedFeeCount();
    };

    // Navigate to Time Entries page with filters pre-applied for unassigned fixed fee entries
    const handleReviewEntries = () => {
      if (props.tracking) {
        const payload = {
          unassignedCount: unassignedCount.value,
          sourcePage: 'fixed-fees'
        };
        EventTracker.trackEvent(props.tracking, 'Unassigned Fixed Fee Time', TrackingAction.ALERT_CLICKED, payload);
      }
      routeService.go('time', {
        fixedFeeAssignment: 'Unassigned'
      });
    };
    onMounted(fetchUnassignedCount);

    // Handle panel closed - clear URL params without triggering route change
    const handlePanelClosed = () => {
      if (props.state?.go) {
        props.state.go('fixedfees', {
          panel: null,
          chargeId: null,
          matterId: null
        }, {
          notify: false,
          reload: false
        });
      }
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(LlWarningBanner, {
        visible: unassignedCount.value > 0,
        "button-text": "Review Entries",
        "banner-class": "mb-4",
        onAction: handleReviewEntries
      }, {
        default: _withCtx(() => [_createTextVNode(" There " + _toDisplayString(unassignedCount.value === 1 ? 'is' : 'are') + " ", 1), _createElementVNode("b", null, _toDisplayString(unassignedCount.value) + " unassigned fixed fee time " + _toDisplayString(unassignedCount.value === 1 ? 'entry' : 'entries'), 1), _cache[1] || (_cache[1] = _createTextVNode(" that need review. These entries are tracked but not linked to any specific fee. ", -1))]),
        _: 1
      }, 8, ["visible"]), _createVNode(FixedFeesTable, {
        state: __props.state,
        leanLawAuth: __props.leanLawAuth,
        tracking: __props.tracking,
        routePanelParams: routePanelParams.value,
        ref_key: "tableRef",
        ref: tableRef,
        onPanelClosed: handlePanelClosed
      }, null, 8, ["state", "leanLawAuth", "tracking", "routePanelParams"])])])]), _createVNode(CreateChargeModal, {
        modelValue: showModal.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showModal.value = $event),
        state: __props.state,
        stateParams: modalStateParams.value,
        tracking: __props.tracking,
        entryPoint: "fixed_fee_list",
        isfromVue: true,
        onClose: handleModalClose
      }, null, 8, ["modelValue", "state", "stateParams", "tracking"])]);
    };
  }
};